var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72902 5.08875C7.79092 5.04577 7.79091 4.95423 7.72902 4.91125L2.4513 1.24616C2.37965 1.19641 2.28162 1.24768 2.28162 1.33491L2.28162 8.66509C2.28162 8.75232 2.37965 8.80359 2.4513 8.75383L7.72902 5.08875ZM8.42751 3.90544C9.19083 4.43552 9.19083 5.56448 8.42751 6.09456L3.14978 9.75965C2.26612 10.3733 1.05706 9.74092 1.05706 8.66509L1.05706 1.33491C1.05706 0.259073 2.26612 -0.373304 3.14978 0.24035L8.42751 3.90544Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.b522bf3556157d03f6d4e0b16875f628.svg";
export { ForwardRef as ReactComponent };